import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { WellbeanChangePasswordSentComponent } from './wellbean-change-password-sent/wellbean-change-password-sent.component';
import { WellbeanForgotPasswordComponent } from './wellbean-forgot-password/wellbean-forgot-password.component';
import { WellbeanInputComponent } from './wellbean-input/wellbean-input.component';
import { WellbeanLoginComponent } from './wellbean-login/wellbean-login.component';
import { WellbeanOemHeaderComponent } from './wellbean-oem-header/wellbean-oem-header.component';
import { WellbeanOemLoginMessageComponent } from './wellbean-oem-login-message/wellbean-oem-login-message.component';
import { WellbeanOemRegisterMessageComponent } from './wellbean-oem-register-message/wellbean-oem-register-message.component';
import { WellbeanPasswordInputComponent } from './wellbean-password-input/wellbean-password-input.component';
import { WellbeanRegisterResendComponent } from './wellbean-register-resend/wellbean-register-resend.component';
import { WellbeanRegisterSendComponent } from './wellbean-register-send/wellbean-register-send.component';
import { WellbeanRegisterComponent } from './wellbean-register/wellbean-register.component';
import { WellbeanResetPasswordComponent } from './wellbean-reset-password/wellbean-reset-password.component';
import { WellbeanUnblockComponent } from './wellbean-unblock/wellbean-unblock.component';
import { WellbeanComponent } from './wellbean/wellbean.component';

@NgModule({
  declarations: [
    WellbeanComponent,
    WellbeanLoginComponent,
    WellbeanRegisterComponent,
    WellbeanUnblockComponent,
    WellbeanRegisterResendComponent,
    WellbeanRegisterSendComponent,
    WellbeanForgotPasswordComponent,
    WellbeanResetPasswordComponent,
    WellbeanChangePasswordSentComponent,
    WellbeanInputComponent,
    WellbeanPasswordInputComponent,
    WellbeanOemHeaderComponent,
    WellbeanOemRegisterMessageComponent,
    WellbeanOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    WellbeanResetPasswordComponent,
    WellbeanComponent,
    WellbeanRegisterResendComponent,
    WellbeanRegisterSendComponent,
    WellbeanUnblockComponent,
    WellbeanChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WellbeanModule {}
